module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei3.svg";